module.exports = __webpack_public_path__ + "img/Driving Simulator Ultimate Pro.1735dd3b.png";